import BigNumber from 'bignumber.js';

// REQUIRE DOUBLE CHECK, CANNOT FIND WHERE THE CODE OUT PUT DATA IN THIS STRUCTURE
// share.availability.total
export default function isShareEmpty(share): boolean {
  return new BigNumber(share.availability.total).lte(0);
}
